module.exports = __webpack_public_path__ + "static/hopin-bus-8720bd1863d64f86972093b3f38dfd4e.png";